"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _textPreview = _interopRequireDefault(require("@gravity/text-preview"));
var _product = require("@nucleo/product");
var _ProductHelper = _interopRequireDefault(require("./ProductHelper"));
var _jsxFileName = "/codebuild/output/src828252154/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductSticker.js",
  _templateObject,
  _templateObject2,
  _this = void 0;
function cov_20ri5kfw1y() {
  var path = "/codebuild/output/src828252154/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductSticker.js";
  var hash = "57aa5f35b06329d48cb364e35c3bc71173dd2dfb";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src828252154/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductSticker.js",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 16
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "1": {
        start: {
          line: 11,
          column: 22
        },
        end: {
          line: 11,
          column: 80
        }
      },
      "2": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 19,
          column: 45
        }
      },
      "3": {
        start: {
          line: 22,
          column: 20
        },
        end: {
          line: 27,
          column: 1
        }
      },
      "4": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 25,
          column: 35
        }
      },
      "5": {
        start: {
          line: 32,
          column: 23
        },
        end: {
          line: 38,
          column: 1
        }
      },
      "6": {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 37,
          column: 12
        }
      },
      "7": {
        start: {
          line: 40,
          column: 0
        },
        end: {
          line: 47,
          column: 2
        }
      },
      "8": {
        start: {
          line: 49,
          column: 0
        },
        end: {
          line: 52,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 11,
            column: 13
          },
          end: {
            line: 11,
            column: 14
          }
        },
        loc: {
          start: {
            line: 11,
            column: 22
          },
          end: {
            line: 11,
            column: 80
          }
        },
        line: 11
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 17,
            column: 18
          },
          end: {
            line: 17,
            column: 19
          }
        },
        loc: {
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 19,
            column: 45
          }
        },
        line: 18
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 23,
            column: 11
          },
          end: {
            line: 23,
            column: 12
          }
        },
        loc: {
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 25,
            column: 35
          }
        },
        line: 24
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 32,
            column: 23
          },
          end: {
            line: 32,
            column: 24
          }
        },
        loc: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 37,
            column: 12
          }
        },
        line: 33
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 19,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 18,
            column: 5
          },
          end: {
            line: 18,
            column: 10
          }
        }, {
          start: {
            line: 18,
            column: 14
          },
          end: {
            line: 18,
            column: 25
          }
        }, {
          start: {
            line: 18,
            column: 29
          },
          end: {
            line: 18,
            column: 48
          }
        }, {
          start: {
            line: 18,
            column: 52
          },
          end: {
            line: 18,
            column: 90
          }
        }, {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 19,
            column: 45
          }
        }],
        line: 18
      },
      "1": {
        loc: {
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 25,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 24,
            column: 5
          },
          end: {
            line: 24,
            column: 16
          }
        }, {
          start: {
            line: 24,
            column: 20
          },
          end: {
            line: 24,
            column: 39
          }
        }, {
          start: {
            line: 24,
            column: 43
          },
          end: {
            line: 24,
            column: 76
          }
        }, {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 25,
            column: 35
          }
        }],
        line: 24
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0, 0, 0, 0],
      "1": [0, 0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "57aa5f35b06329d48cb364e35c3bc71173dd2dfb"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_20ri5kfw1y = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_20ri5kfw1y();
var Wrapper = (cov_20ri5kfw1y().s[0]++, _styledComponents.default.div.attrs({
  className: function className(props) {
    cov_20ri5kfw1y().f[0]++;
    cov_20ri5kfw1y().s[1]++;
    return "stx-ProductSticker stx-ProductSticker-".concat(props.productId);
  }
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  border-bottom: 1px solid;\n  padding-bottom: ", ";\n  width: 100%;\n  position: relative;\n  border-color: ", ";\n"])), _stylingConstants.default.spacing.xxsmall, function (props) {
  cov_20ri5kfw1y().f[1]++;
  cov_20ri5kfw1y().s[2]++;
  return (cov_20ri5kfw1y().b[0][0]++, props) && (cov_20ri5kfw1y().b[0][1]++, props.theme) && (cov_20ri5kfw1y().b[0][2]++, props.theme.product) && (cov_20ri5kfw1y().b[0][3]++, props.theme.product.stickerBorderColor) || (cov_20ri5kfw1y().b[0][4]++, _stylingConstants.default.color.disabledBackground);
}));
var ProductName = (cov_20ri5kfw1y().s[3]++, (0, _styledComponents.default)(_textPreview.default)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-size: 1rem;\n"])), function (props) {
  cov_20ri5kfw1y().f[2]++;
  cov_20ri5kfw1y().s[4]++;
  return (cov_20ri5kfw1y().b[1][0]++, props.theme) && (cov_20ri5kfw1y().b[1][1]++, props.theme.product) && (cov_20ri5kfw1y().b[1][2]++, props.theme.product.nameTextColor) || (cov_20ri5kfw1y().b[1][3]++, _stylingConstants.default.color.baseText);
}));

/*
 * Component to display a product as a sticker. It contains the image, the name and the time (not the date)
 */
cov_20ri5kfw1y().s[5]++;
var ProductSticker = function ProductSticker(props) {
  cov_20ri5kfw1y().f[3]++;
  cov_20ri5kfw1y().s[6]++;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 3
    }
  }, /*#__PURE__*/_react.default.createElement(ProductName, {
    lines: 1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 5
    }
  }, _ProductHelper.default.getProductTitle({
    product: props.product,
    performance: props.performance
  })));
};
cov_20ri5kfw1y().s[7]++;
ProductSticker.propTypes = {
  /* The product object to display */
  product: _product.ProductType.isRequired,
  /* A specific performance to display, if provided take the performance data in priority */
  performance: _product.PerformanceType,
  /* a specific timeslot to display, if provided take the timeslotData in priority */
  timeslot: _product.TimeslotType
};
cov_20ri5kfw1y().s[8]++;
ProductSticker.defaultProps = {
  performance: undefined,
  timeslot: undefined
};
var _default = exports.default = ProductSticker;